import { REGISTER_SUCCESS, REGISTER_FAIL, LOAD_USER, AUTH_FAILED, LOGIN_SUCCESS, LOGIN_FAIL, LOG_OUT, ADD_AMOUNT_FAIL, ADD_AMOUNT_SUCCESS, SET_FUTURE_ESTIMATE_SUCCESS, SET_FUTURE_ESTIMATE_FAIL, REMOVE_ALL_ALERTS} from "./types";
import { BreathAPIs } from "../APIs/BreathAPIs";
import { setAlert } from "./Alert";
import setAuthToken from "../Utils/setAuthToken";

//load user
export const loadUser = () => async dispatch => {
    if(localStorage.token){
        setAuthToken(localStorage.token)
    }
    try{
        const res = await BreathAPIs.getUser()
        dispatch({
            type: LOAD_USER,
            payload:res.data
        })
    }
    catch(err){
        dispatch({
            type: AUTH_FAILED
        })
    
}
}

//register user
export const register = (userDetails) => async dispatch =>{
   try{
    const res = await BreathAPIs.registerUser(userDetails)
    dispatch({
        type: REGISTER_SUCCESS,
        payload:res.data});
    if (res.status === 200){
        dispatch(setAlert('Registered Successfully', 'success'))
        return true;
    }
    return false;
    //dispatch(loadUser())
   }
   catch(err){
        const errors = err.response.data.errors
        if (errors){
            console.log('sa', err.response.data.errors)
            if (err.response && err.response.data && err.response.data.errors && err.response.data.errors) {
                const errorMsg = err.response.data.errors.msg;
                dispatch(setAlert(errorMsg,'danger'));
            } else {
                dispatch(setAlert("Error creating user.",'danger'));
            }
        }
        dispatch({
            type: REGISTER_FAIL
        })
        return false;
   }
}

//login user
export const login = (userDetails) => async dispatch =>{
    try{
     const res = await BreathAPIs.loginUser(userDetails)
     dispatch({
         type: LOGIN_SUCCESS,
         payload:res.data
     })
     //dispatch(setAlert('Registered Successfully', 'success'))
     dispatch(loadUser())
     dispatch({type: REMOVE_ALL_ALERTS})
    }
    catch(err){
         const errors = err.response.data.errors
         if (errors){
            //errors.forEach((error)=>{dispatch(setAlert(error.msg,'danger'))})
            dispatch(setAlert(errors.msg, 'danger' ,15000))
         }
         dispatch({
             type: LOGIN_FAIL
         })
    }
 }

 export const authLogin = (token) => async dispatch => {
    try{
        dispatch({
            type: LOGIN_SUCCESS,
            payload:{token}
        })
        dispatch(loadUser())
    }
    catch(err){
         const errors = err.response.data.errors
         if (errors){
            dispatch(setAlert('Invalid Credentials', 'danger' ))
         }
         dispatch({
             type: LOGIN_FAIL
         })
    }
 }

 export const logout = () => async dispatch => {
    dispatch({
        type: LOG_OUT
    })
 }




 export const addAmount = (amount) => async dispatch => {
    
        try{
          const res = await BreathAPIs.updateWalletCoins(localStorage.token, amount)
          dispatch({
              type : ADD_AMOUNT_SUCCESS,
              payload : res.data
          })
          dispatch(loadUser())
        }
        catch(err){
        //   const errors = err.response.data.errors
           if (err){
              //errors.forEach((error)=>{dispatch(setAlert(error.msg,'danger'))})
              dispatch(setAlert('Amount could not be added', 'danger' ))
           }
           dispatch({
               type: ADD_AMOUNT_FAIL
           })
        }  
      // }
  }

  

 export const setFutureEstimateAmount = (estimateAmount) => async dispatch => {
    
        try{
          
          dispatch({
              type : SET_FUTURE_ESTIMATE_SUCCESS,
              payload : estimateAmount
          })
          dispatch(loadUser())
        }
        catch(err){
        //   const errors = err.response.data.errors
           if (err){
              //errors.forEach((error)=>{dispatch(setAlert(error.msg,'danger'))})
              dispatch(setAlert('Failed to get Future estimate', 'danger' ))
           }
           dispatch({
               type: SET_FUTURE_ESTIMATE_FAIL
           })
        }  
      // }
  }